module.exports = __webpack_public_path__ + "static/media/tent.b67595e5.png";